import { ActionTypesChat } from "../constants/action-types"

const intitialState = {
    messages:[],
    participants:[],
    isSocketConnected:true,
    isBotConnected:false,
    socketInstance:null,
    engagementParam:{}
}

export const chatReducer = (state=intitialState,action)=>{
    
    switch(action.type){
        case ActionTypesChat.NEW_MESSAGE_RECEIVED:{
            return {
                ...state,
                messages:[...state.messages,action.payload.message],
                isBotConnected: (action.payload.message?.senderParticipantType == "SYSTEM") ? true : false,
            }
        }

        case ActionTypesChat.ADD_PARTICIPANT:{
            let participantType = action.payload.participant.participantType
            let participantName = action.payload.participant.displayName
            let currentTime = Date.now();
            return {
                ...state,
               participants:[...state.participants,action.payload.participant],
               messages: (participantType == "AGENT") ? [...state.messages, {'body': {'elementText': {'text': participantName}, "elementType": "text"}, "senderType": "PARTICIPANT_ADDED", "lastUpdatedTimestamp": currentTime}] : [],
               isBotConnected: false
            }
        }

        case ActionTypesChat.REMOVE_PARTICIPANT:{
            let participant = action.payload.participant;
            let participantType = action.payload.participant.participantType
            let participantName = action.payload.participant.displayName
            let currentTime = Date.now();
            return {
                ...state,
               participants:[...state.participants.filter(p=>p.participantId!=participant.participantId)],
               messages: (participantType == "AGENT") ? [...state.messages, {'body': {'elementText': {'text': participantName}, "elementType": "text"}, "senderType": "PARTICIPANT_REMOVED", "lastUpdatedTimestamp": currentTime}] : [...state.messages],
               isBotConnected: false
            }
        }

        case ActionTypesChat.ENGAGEMENT_CREATED:{
            if(action.payload.participant.eventType ==  "ENGAGEMENT_CREATED" ) {
                var engagementParameters = { ...action.payload.participant.engagementParameters, "engagement_id" : action.payload.participant.engagementId }
                return { 
                    ...state,
                    engagementParam: engagementParameters
                }
            }
            return state;

        }

        case ActionTypesChat.SET_SOCKET_CONNECTIVITY:{
            return {
                ...state,
                isSocketConnected:action.payload.isSocketConnected,
            }
        }

        case ActionTypesChat.SET_SOCKET_INSTANCE:{
            return {
                ...state,
                socketInstance:action.payload.socket,
            }
        }
        

        case ActionTypesChat.INIT_CHAT:{
            return state;
        }

        case "URL":{
            return state;
        }

        default:{
            return state;
        }
    }
}

export default chatReducer;



